module.exports = __webpack_public_path__ + "static/service-provide-badge-27c5dc3e6db114bab85aa1f94758f880.png";